import { Component, HostBinding, ViewEncapsulation } from '@angular/core';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';
import { createDownloadabeFileFromResponseAndSave } from '../../../../utils';

@Component({
  selector: 'form-file-field',
  standalone: false,
  encapsulation: ViewEncapsulation.None,
  styles: [
    `
      .form-file-field {
        display: flex;
        flex-direction: column;
        flex: 1;
        .file-label {
          pointer-events: none;
          top: var(--p-iftalabel-top);
          transition-property: all;
          transition-timing-function: ease;
          line-height: 1;
          font-size: var(--p-iftalabel-font-size);
          font-weight: var(--p-iftalabel-font-weight);
          inset-inline-start: var(--p-iftalabel-position-x);
          color: var(--p-iftalabel-color);
          transition-duration: var(--p-iftalabel-transition-duration);
          margin-bottom: 0.7rem;
        }
        .p-fileupload-basic {
          justify-content: flex-start;
        }
      }
    `,
  ],
  template: `
    <input type="hidden" [formControl]="formControl" />
    <div>
      <div *ngIf="field.props.label" class="file-label">
        {{
          field.props['translate']
            ? (field.props.label | translate)
            : field.props.label
        }}
      </div>

      <p-fileupload
        *ngIf="!hasFileSelected()"
        #fu
        mode="basic"
        chooseLabel="Choose"
        chooseIcon="pi pi-upload"
        name="demo[]"
        url="https://www.primefaces.org/cdn/api/upload.php"
        [accept]="field.props['accept'] || null"
        [maxFileSize]="field.props['maxFileSize'] || null"
        class="flex"
        [fileLimit]="1"
        [customUpload]="true"
        [disabled]="false"
        (onUpload)="onUpload($event)"
        (uploadHandler)="uploadHandler($event)"
        (onSelect)="onSelect($event)"
        [pTooltip]="
          field.props['translate']
            ? (field.props['tooltip'] || '' | translate)
            : field.props['tooltip']
        "
        tooltipPosition="top"
      />
      <div
        *ngIf="hasFileSelected()"
        class="flex flex-wrap items-center content-center gap-2"
      >
        <p-button
          [label]="'formsCommon.editor.action.delete' | translate"
          icon="pi pi-trash"
          (click)="deleteFile()"
        />
        <p-button
          (click)="onDownloadFile()"
          [label]="'formsCommon.editor.action.download' | translate"
          icon="pi pi-download"
          iconPos="left"
        />
        <p-button
          class="button--only-disabled-form"
          (click)="onDownloadFile()"
          [label]="'formsCommon.editor.action.download' | translate"
          icon="pi pi-download"
          iconPos="left"
        />
        <span>{{ getFilename() }}</span>
      </div>
    </div>
  `,
})
export class FormFileFieldType extends FieldType<FieldTypeConfig> {
  @HostBinding('class')
  readonly cssClass = 'form-file-field';

  onUpload($event: any): void {}

  onSelect($event: any): void {
    const self = this;

    if ($event.currentFiles?.length) {
      const file = $event.currentFiles[0];
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onloadend = function () {
        const extendedDataUrl = `filename:${btoa(file.name)};${reader.result}`;
        self.formControl.setValue(extendedDataUrl);
      };
      reader.onerror = function (error) {};
    }
  }
  uploadHandler($event: any): void {}

  deleteFile(): void {
    this.formControl.setValue(undefined);
  }
  getFilename(): string {
    return atob(this.formControl.getRawValue().split(';')[0].split(':')[1]);
  }
  getFilemime(): string {
    return this.formControl.getRawValue().split(';')[1].split(':')[1];
  }

  getFiledata(): string {
    return this.formControl.getRawValue().split(';')[2].split(',')[1];
  }

  hasFileSelected(): boolean {
    return !!this.formControl.getRawValue();
  }
  onDownloadFile(): void {
    createDownloadabeFileFromResponseAndSave({
      status: 'success',
      dataInfo: {
        type: 'file',
        fileName: this.getFilename(),
        fileMime: this.getFilemime(),
      },
      data: this.getFiledata(),
    });
  }
}
